import { getSettingsGetQuickPurchaseSettings } from "api"
import SeoMetaData from "common/SeoMetaData"
import KeyboardNavigation from "components/KeyboardNavigation/KeyboardNavigation"
import QuickPurchaseProcess from "components/QuickPurchasePage/QuickPurchaseProcess"
import { useState } from "react"

export const getStaticProps = async () => {
  // Generate Mock Data
  const settings = await getSettingsGetQuickPurchaseSettings()

  const seo = {
    title: "הזנת פרטים לצורך רכישת גיפטקארד ברשת מקדונלד'ס",
    description:
      "הגיפט קארד של מקדונלד'ס ישראל. בואו להפתיע חברים ומשפחה. בוחרים עיצוב, סכום קניה, מקדישים ברכה וזהו..",
    keywords: "גיפט קארד מקדונלד'ס | McDonald's giftcard",
  }

  return {
    props: {
      settings: settings?.data,
      seo,
    },
    revalidate: 60,
  }
}

const QuickPurchase = ({ settings, seo }) => {
  const [refList] = useState([])

  return (
    <>
      <KeyboardNavigation refList={refList} />
      <SeoMetaData data={seo} />
      <QuickPurchaseProcess settings={settings?.body} />
    </>
  )
}

export default QuickPurchase
